import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { debounceTime } from "rxjs/operator/debounceTime";
import { Subject, Subscription } from "rxjs/Rx";
import { AccessTerminalService } from "../../../shared/services/user/access-terminal.service";
import { User } from "../../../shared/user/user";
import { FileUploadService } from "../../../shared/services/fileuploadservice";
import { LoaderService } from "../../../shared/services/loader.service";
import { IMyDpOptions } from "mydatepicker";
import { CommunityService } from "../../../shared/services/community/community.service";
import { AuthService } from "../../../shared/services/auth.service";
import { BackendService } from "../../../shared/services/backend.service";
import * as firebase from "firebase/app";
import * as EmailValidator from "email-validator";
import { IShift } from "./../../../helper/contracts";
import { Shift } from "./../../../shared/services/shift/shift";
import { ShiftService } from "./../../../shared/services/shift/shift.service";
import { Constants } from "./../../../helper/constants";

@Component({
  selector: "app-access-terminal",
  templateUrl: "./access-terminal.component.html",
  styleUrls: ["./access-terminal.component.css"]
})
export class AccessTerminalComponent implements OnInit, OnDestroy {
  currentDate = new Date();

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: "yyyy-mm-dd",
    editableDateField: false,
    disableSince: {
      year: this.currentDate.getFullYear(),
      month: this.currentDate.getMonth() + 1,
      day: this.currentDate.getDate() + 1
    }
  };

  private _alert: Subject<string> = new Subject<string>();
  private alertSubscription: Subscription = new Subscription();
  private accessTerminals$: Subscription = new Subscription();
  private uploadedAvatarURL$: Subscription = new Subscription();
  modalReference: NgbModalRef;
  accessTerminals: Array<User>;
  page = 1;
  query = "";
  user: User;
  singleAccessTerminal: any;
  accessTerminalMirrored: any;
  communityId: string;
  community;
  confirmationMessage = "";
  confirmationTitle = "";
  successMessage = "";
  errorMessage = "";
  emailNotUniqueError = "";
  genders = ["Female", "Male"];
  activeRouteIndex: number;
  routeSubscription: Subscription = new Subscription();
  tempDateOfBirth;
  validEmail: boolean;
  actionType = "";
  userId: string;
  authState: firebase.User | null;
  shifts: Array<IShift> = [];
  shift;
  newShifts: Array<IShift> = [];
  newShift;
  userAssignedShifts = [];
  accessTerminalShifts = {};

  constructor(
    private authService: AuthService,
    private communityService: CommunityService,
    private modalService: NgbModal,
    private accessTerminalService: AccessTerminalService,
    private uploadService: FileUploadService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private shiftService: ShiftService
  ) {
    this.user = new User();
    this.accessTerminals = [];
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.routeSubscription = this.route.params.subscribe(params => {
      this.communityId = params.communityId;

      this.shiftService.getCommunityAssignedShifts(this.communityId).subscribe(
        assignedShifts => this.accessTerminalShifts = assignedShifts
      );

      this.communityService
        .getCommunityById(params.communityId)
        .subscribe(data => (this.community = data));

      this.publishShifts();

      this.shift = new Shift();
      this.shiftService.getShifts(this.communityId).subscribe(shifts => {
        this.shifts = shifts.filter(shift => shift.isActive);
      });
    });
  }

  ngOnDestroy(): void {
    this.closeModal();
    this.routeSubscription.unsubscribe();
    this.accessTerminals$.unsubscribe();
    this.uploadedAvatarURL$.unsubscribe();
  }

  publishShifts(): void {
    this.shiftService
    .getCommunityAssignedShifts(this.communityId)
    .subscribe(assignedShifts => {
      this.accessTerminals$ = this.accessTerminalService
        .list(this.communityId)
        .subscribe(data => {
          this.accessTerminals = data;
          for (const i in data) {
            if (data[i]) {
              const user = data[i];
              const userId = user["id"];
              this.accessTerminals[i]["shifts"] =
                assignedShifts[userId] ? this.removeDuplicate(assignedShifts[userId], "id") : [];
            }
          }
          this.loaderService.stopLoader();
        });
    });
  }

  removeDuplicate(arr, comp): Array<any> {
    const unique = arr.map(e => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => arr[e]).map(e => arr[e]);

    return unique;
  }

  viewAccessTerminal(modal, accessTerminal): void {
    this.singleAccessTerminal = accessTerminal;
    if (this.modalReference) {
      this.closeModal();
    }
    if (this.singleAccessTerminal.dateOfBirth.date) {
      this.tempDateOfBirth = this.singleAccessTerminal.dateOfBirth.date;
    } else {
      this.tempDateOfBirth = this.singleAccessTerminal.dateOfBirth;
      this.singleAccessTerminal.dateOfBirth = {
        date: this.singleAccessTerminal.dateOfBirth
      };
    }
    this.newShifts = [];
    this.openModal(modal, "md");
  }

  async hasOverlappingShift(): Promise<boolean> {
    if (this.accessTerminalShifts !== {} &&
      this.accessTerminalShifts[this.singleAccessTerminal["id"]]) {

        const userAssignedShifts = this.accessTerminalShifts[this.singleAccessTerminal["id"]];
        const DAYS_OF_THE_WEEK = Constants.DAYS_OF_THE_WEEK;

        const overlappingShifts = userAssignedShifts.filter(shift => {

          let hasOverlappingDays = false;

          if (this.newShift.isSpecial) {
            const newSpecialDate = new Date(this.newShift.specialDay);
            hasOverlappingDays = shift.isSpecial ? newSpecialDate.getDay() === new Date(shift.specialDay).getDay() :
            (newSpecialDate.getDay() >= DAYS_OF_THE_WEEK[shift.startDay] && newSpecialDate.getDay() <= DAYS_OF_THE_WEEK[shift.endDay]);
          } else {
            hasOverlappingDays =
            (DAYS_OF_THE_WEEK[this.newShift.startDay] >= DAYS_OF_THE_WEEK[shift.startDay] &&
              DAYS_OF_THE_WEEK[this.newShift.startDay] <= DAYS_OF_THE_WEEK[shift.endDay]) ||
              (DAYS_OF_THE_WEEK[this.newShift.endDay] > DAYS_OF_THE_WEEK[shift.startDay] &&
                DAYS_OF_THE_WEEK[this.newShift.endDay] <= DAYS_OF_THE_WEEK[shift.endDay]);
          }

          let hasOverlappingTime = false;
          if (hasOverlappingDays) {
            if (this.newShift.isSpecial) {
                hasOverlappingTime = (this.newShift.startTime >= shift.startTime && this.newShift.startTime <= shift.endTime) ||
                (this.newShift.endTime > shift.startTime && this.newShift.endTime <= shift.endTime);
            } else {
              hasOverlappingTime =
              (this.newShift.startTime >= shift.startTime && this.newShift.startTime <= shift.endTime) ||
              (this.newShift.endTime > shift.startTime && this.newShift.endTime <= shift.endTime);
            }
          }

          return (hasOverlappingDays && hasOverlappingTime);
        });

        return overlappingShifts.length ? true : false;
      }

    return true;
  }

  addNewShift(): void {
    if (this.newShift) {
      const shifts = this.singleAccessTerminal["shifts"]
        ? [...this.singleAccessTerminal["shifts"], ...this.newShifts]
        : [...this.newShifts];

      if (!shifts.length) {
        this.newShifts.push(this.newShift);
        this.newShift = null;
      } else {
        for (const shift of shifts) {
          if (this.newShift["name"] === shift["name"]) {
            alert("Please select a unique shift ...");

            return;
          }
        }
        if (this.newShift.isSpecial) {
          if (new Date(this.newShift.specialDay).getDay() < new Date().getDay()) {
            alert("Oops, can't assign this shift because it has expired.");

            return ;
          }
        }
        this.hasOverlappingShift().then(hasOverlappingShift => {
          if (!hasOverlappingShift) {
            this.newShifts.push(this.newShift);
            this.newShift = null;
          } else {
            alert("Either day or time is overlapping with assigned shift(s), please select a non-overlapping shift.");
          }
        });
      }
    } else {
      alert("Please select a shift ...");
    }
  }

  removeNewShift(index): void {
    this.newShifts.splice(index, 1);
  }

  async assignShifts(): Promise<void> {
    this.loaderService.startLoader();
    const result = await this.shiftService.assignShifts(
      this.newShifts,
      this.communityId,
      this.singleAccessTerminal["id"]
    );
    if (result) {
      this.showAlert(result, "Shift successfully assigned");
    } else {
      this.showAlert(result, "An error occured while trying to assign a shift");
    }
    this.newShifts = [];
    this.loaderService.stopLoader();
    this.closeModal();
    this.publishShifts();
  }

  deleteShift(shift, modal): void {
    this.shift = shift;
    const message = `Are you sure you want to delete shift "${
      shift.name
    }" from ${this.singleAccessTerminal.firstName} ${
      this.singleAccessTerminal.lastName
    }?`;
    this.confirm("Delete Shift!", message, modal);
  }

  async unassignShift(): Promise<void> {
    this.loaderService.startLoader();
    const result = await this.shiftService.unassignShift(
      this.shift,
      this.communityId,
      this.singleAccessTerminal["id"]
    );

    if (result) {
      this.showAlert(result, "Shift successfully unassigned");
    } else {
      this.showAlert(
        result,
        "An error occured while trying to unassign a shift"
      );
    }
    this.shift = {};
    this.loaderService.stopLoader();
    this.closeModal();
    this.publishShifts();
  }

  createOrEditAccessTerminal(modal, user: any): void {
    if (user) {
      this.closeModal();
    }
    this.accessTerminalMirrored = { ...new User(), ...user };
    this.openModal(modal, "md");
  }

  openImageUploader(): void {
    const element = document.getElementById("imageUploader") as HTMLElement;
    element.click();
  }

  uploadImage(event): void {
    this.loaderService.startLoader();
    const file = event.target.files[0];
    const imgURL = this.uploadService.upload("avatars", file);
    this.uploadedAvatarURL$ = imgURL.subscribe(data => {
      this.accessTerminalMirrored.avatar = data;
      this.loaderService.stopLoader();
    });
  }

  confirmDelete(user: any, modal): void {
    this.user = user;
    const message = `Are you sure you want to delete ${user.firstName} ${
      user.lastName
    }?`;
    this.confirm("Delete Access Terminal!", message, modal);
  }

  async saveAccessTerminal(): Promise<void> {
    this.loaderService.startLoader();
    this.accessTerminalMirrored.dateOfBirth.date !== this.tempDateOfBirth
      ? (this.accessTerminalMirrored.dateOfBirth = this.accessTerminalMirrored.dateOfBirth.formatted)
      : (this.accessTerminalMirrored.dateOfBirth = this.tempDateOfBirth);
    let result = await this.authService.authenticateNewUser(
      this.accessTerminalMirrored.email
    );
    if (!result.state) {
      this.showAlert(result.state, result.message);
    } else {
      const userId = result.message;

      if (this.accessTerminalMirrored.hasOwnProperty("shifts")) {
        delete this.accessTerminalMirrored.shifts;
      }
      if (this.accessTerminalMirrored.hasOwnProperty("isActiveAT")) {
        delete this.accessTerminalMirrored.isActiveAT;
      }
      if (this.accessTerminalMirrored.hasOwnProperty("hasRoles")) {
        delete this.accessTerminalMirrored.hasRoles;
      }

      if (userId && !this.accessTerminalMirrored.id) {
        this.accessTerminalMirrored.id = userId;
        result = await this.accessTerminalService.create(this.accessTerminalMirrored, this.community);
      } else if (userId && this.accessTerminalMirrored.id) {
        result = await this.accessTerminalService.update(this.accessTerminalMirrored, this.community);
      }
      this.showAlert(result.state, result.message);
    }
    this.loaderService.stopLoader();
    this.closeModal();
  }

  deleteAccessTerminal(): void {
    this.accessTerminalService.delete(this.communityId, this.user.id);
    this.closeModal();
    this.showAlert(true, "Access terminal deleted successfully.");
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.closeModal();
    this.openModal(modal, "sm");
  }

  confirmAction(type, user: any, modal): void {
    this.user = user;
    this.actionType = type;
    const message = `Are you sure you want to ${type} ${user.firstName} ${
      user.lastName
    }"s account?`;
    this.confirm("Attention!", message, modal);
  }

  deactivateAccessTerminal(): void {
    this.accessTerminalService.deactivate(
      this.communityId,
      this.singleAccessTerminal.id
    );
    this.closeModal();
    this.showAlert(true, "Access Terminal Personnel deactivated successfully.");
  }

  activateAccessTerminal(): void {
    this.accessTerminalService.activate(
      this.communityId,
      this.singleAccessTerminal.id
    );
    this.closeModal();
    this.showAlert(true, "Access Terminal Personnel activated successfully.");
  }

  openModal(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  showAlert(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(message =>
      msgType ? (this.successMessage = message) : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(() =>
        msgType
          ? (this.successMessage = undefined)
          : (this.errorMessage = undefined)
      );
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  isNumber(event: any): boolean {
    const charCode = event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }

  isLetter(event: any): boolean {
    const letters = /^[A-Za-z]+$/;
    const charKey = event.key;
    if (!charKey.match(letters)) {
      return false;
    }

    return true;
  }

  isEmail(email: string): void {
    this.validEmail = EmailValidator.validate(email);
  }
}



// WEBPACK FOOTER //
// ./src/app/community-management/community-resources/access-terminal/access-terminal.component.ts